export const getTiming = (time) => {
  const newtime = time * 100;
  if (newtime >= 100) {
    return (newtime / 100).toFixed() + " روز پیش";
  } else if (newtime < 100 && newtime > 4) {
    return ((newtime * 24) / 100).toFixed() + " ساعت پیش";
  } else {
    return "دقایقی پیش";
  }
};
